import React from "react";

const CheckModal = ({
  IsCheckModal,
  checkDetails,
  baseUrl,
  isEdit,
  setIsCheckModal,
  toggleSubCategories,
  selectedCheckService,
  ChangeCheckService,
  selectedCheckOffer,
  setCheckedOffer,
  ChangeOfferPrice,
  totalPrice,
  totalOfferPrice,
  checkedOffer,
  handleCheckOffer,
  handleCheckService,
  getCheckOfferDetails,
}) => {
  return (
    IsCheckModal && (
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={IsCheckModal ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            {checkDetails && (
              <>
                <div
                  className="modal-header orderDetails-modalHeader px-4"
                  style={{ backgroundColor: checkDetails.background_color }}
                >
                  {isEdit ? (
                    <i
                      className="fa-solid fa-circle-xmark fa-xl cursor"
                      onClick={() => setIsCheckModal(false)}
                    ></i>
                  ) : (
                    <i
                      onClick={() => toggleSubCategories()}
                      className="fa-solid fa-chevron-left cursor"
                    ></i>
                  )}
                  <div className="d-flex align-items-center mx-auto">
                    <p
                      className="modal-title orderDetails-modalTitle fs-3 mx-2 fw-semibold"
                      id="exampleModalLabel"
                    >
                      {checkDetails.name}
                    </p>
                    <img
                      src={`${baseUrl}${checkDetails.icon_url}`}
                      alt={checkDetails.name}
                    />
                  </div>
                </div>
                <div className="modal-body orderDetails-modalBody p-3">
                  <h6 className="text-end text-muted fw-semibold mb-4">
                    {checkDetails.description}
                  </h6>
                  {checkDetails.services.map((service) => (
                    <div
                      className="d-flex justify-content-between mx-3 my-2"
                      key={service.id}
                    >
                      <p className="fw-semibold">{service.price} EGP</p>
                      <div>
                        <label htmlFor="" className="fw-semibold mx-2">
                          {service.name}
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedCheckService.some(
                            (s) => s.id === service.id
                          )}
                          onChange={(e) => {
                            ChangeCheckService(
                              e.target.checked,
                              service.id,
                              service.price
                            );
                          }}
                          defaultChecked={service.selected}
                        />
                      </div>
                    </div>
                  ))}
                  {checkDetails.offers.map((offer) => (
                    <div
                      key={offer.id}
                      style={{ backgroundColor: checkDetails.background_color }}
                      className="bg-opacity-10 text-end px-3 py-2 rounded-3 my-2"
                    >
                      <div className="d-flex align-items-center">
                        <div className="w-50 text-start">
                          {offer.control_type?.properties?.map((prop) => (
                            <img
                              key={prop.id}
                              className="w-100"
                              src={`${baseUrl}${prop.value}`}
                              alt={prop.name}
                            />
                          ))}
                          <div
                            onClick={() => getCheckOfferDetails(offer.id)}
                            className="d-flex align-items-center my-3 cursor"
                          >
                            <i className="fa-solid fa-chevron-left cursor mx-2"></i>
                            <p className="my-0 fw-semibold">عرض التفاصيل</p>
                          </div>
                        </div>
                        <div className="w-100">
                          <div>
                            <label htmlFor="عرض" className="mx-2">
                              {offer.name}
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedCheckOffer.some(
                                (offerItem) => offerItem.id === offer.id
                              )}
                              onChange={(e) => {
                                setCheckedOffer(e.target.checked);
                                ChangeOfferPrice(
                                  e.target.checked,
                                  offer.id,
                                  offer.offer_price
                                );
                              }}
                              defaultChecked={offer.selected}
                            />
                          </div>
                          <p className="m-2 small">{offer.description}</p>
                          <div style={{ direction: "rtl", textAlign: "right" }}>
                            <p className="my-2 fw-semibold">
                              {offer.offer_price}{" "}
                              <span className="text-start"> بدلا من</span>
                              <span className="text-decoration-line-through mx-1">
                                {offer.total_price}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="bg-secondary d-flex justify-content-between p-3 rounded-3 bg-opacity-25 my-4">
                    <p className="my-0 fw-semibold">
                      {checkedOffer ? totalOfferPrice : totalPrice}
                    </p>
                    <p className="my-0 fw-semibold">الاجمالي</p>
                  </div>
                </div>
              </>
            )}
            <div className="modal-footer mx-auto">
              <button
                type="button"
                className="btn btn-dark px-5 fs-5"
                onClick={() =>
                  checkedOffer ? handleCheckOffer() : handleCheckService()
                }
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default CheckModal;
